'use client';

import { VirtualItem } from '@tanstack/react-virtual';

import { createStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { safeSetLocalStorage } from '@wwe-portal/web/libs/storage/safe-local-storage';

export interface CachedVirtualizer {
  enabledInitialOffset: boolean;
  initialOffset: number | undefined;
  initialMeasurementsCache: VirtualItem[] | undefined;
  cacheData: (data: {
    initialOffset: number | undefined;
    initialMeasurementsCache: VirtualItem[] | undefined;
  }) => void;
  setEnabledInitialOffset: (value: boolean) => void;
  getCachedVirtualizer: () => {
    initialOffset: number | undefined;
    initialMeasurementsCache: VirtualItem[] | undefined;
  };
}

export const createCachedVirtualizerStore = (
  defaultValues: Pick<CachedVirtualizer, 'enabledInitialOffset'>,
  storeName: string
) => {
  return createStore(
    persist<CachedVirtualizer>(
      (set, get) => ({
        ...defaultValues,
        initialOffset: undefined,
        initialMeasurementsCache: undefined,

        cacheData: (data) => set({ ...data }),
        setEnabledInitialOffset: (enabledInitialOffset) =>
          set({ enabledInitialOffset }),
        getCachedVirtualizer: () => ({
          initialOffset: get().enabledInitialOffset ? get().initialOffset : 0,
          initialMeasurementsCache: get().initialMeasurementsCache,
        }),
      }),
      {
        name: storeName,
        // The persisted measurements cache is a large bounded blob; guard the
        // write so a full quota only skips scroll caching instead of crashing.
        storage: createJSONStorage(() => ({
          getItem: (name) => localStorage.getItem(name),
          setItem: (name, value) => {
            safeSetLocalStorage(name, () => value);
          },
          removeItem: (name) => localStorage.removeItem(name),
        })),
      }
    )
  );
};
